module.exports = __webpack_public_path__ + "static/wingman-3997219a0acd0a4af96ca25794e0f703.webp";